import i18n from '../../../../i18n/index';
import utility from '../../../../services/utility-service';

export default {
  /**
   * @returns {*[]}
   */
  getTableHeaders() {
    return [
      {
        value: 'domain.name',
        text: i18n.t('clientPayments.table.domain'),
        align: 'center',
        sortable: true,
        class: 'px-2',
      },
      {
        value: 'live',
        text: i18n.t('clientPayments.table.live'),
        align: 'center',
        sortable: true,
        class: 'px-2',
      },
      {
        value: 'cancelled',
        text: i18n.t('clientPayments.table.cancelled'),
        align: 'center',
        sortable: true,
        class: 'px-2',
      },
      {
        value: 'currency',
        text: i18n.t('clientPayments.table.currency'),
        align: 'center',
        sortable: true,
        width: '40px',
        class: 'px-2',
      },
      {
        value: 'liveInEuro',
        text: i18n.t('clientPayments.table.liveInEuro'),
        align: 'center',
        sortable: true,
        class: 'px-2',
      },
      {
        value: 'cancelledInEuro',
        text: i18n.t('clientPayments.table.cancelledInEuro'),
        align: 'center',
        sortable: true,
        class: 'px-2',
      },
    ];
  },

  /**
   * @param state
   * @returns {*}
   */
  getDomainsForFilter(state) {
    if (state.filter.data.selectedBrands.length === 0) {
      return state.filter.data.domains;
    }
    return state.filter.data.domains.filter((domain) => {
      if (state.filter.data.selectedDomains.includes(domain.id)) {
        return true;
      }
      return state.filter.data.selectedBrands.includes(domain.brand.id);
    });
  },

  /**
   * @param state
   * @returns {*[]}
   */
  getDownloadSearchInfo(state) {
    const lastSearch = state.filter.lastSearch;
    const filterData = state.filter.data;
    if (!lastSearch.performed) {
      return [];
    }

    return [
      {
        label: i18n.t('payments.filters.arrival'),
        value: `${lastSearch.date.arrivalFromDate} - ${lastSearch.date.arrivalToDate}`,
      },
      {
        label: i18n.t('payments.filters.paidDate'),
        value: `${lastSearch.date.paidDateFromDate} - ${lastSearch.date.paidDateToDate}`,
      },
      {
        label: i18n.t('payments.filters.brands'),
        value: `${utility.getNameFromFirstSelectedItem(
          lastSearch.data.selectedBrands,
          filterData.brands,
        )}`,
      },
      {
        label: i18n.t('payments.filters.domains'),
        value: `${utility.getNameFromFirstSelectedItem(
          lastSearch.data.selectedDomains,
          filterData.domains,
        )}`,
      },
    ];
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/payments/clientPayments/getters.js